// extracted by mini-css-extract-plugin
export default {"icon":"F20I7S"};